// Function to handle free shipping display based on detected country
function handleFreeShippingDisplay() {
  fetch('/browsing_context_suggestions.json')
    .then(res => res.json())
    .then(data => {
      const countryCode = data.detected_values.country.handle; // "IE" for Ireland
      const countryName = data.detected_values.country.name;    // "Ireland" or "Northern Ireland"

      console.log("Detected Country Code:", countryCode);
      console.log("Detected Country Name:", countryName);

      const freeShippingBar = document.querySelector('.free-shipping-bar');
      if (!freeShippingBar) return;

      // Show free shipping bar only for Ireland and Northern Ireland
      if (countryCode === 'IE' || countryName === 'Northern Ireland') {
        freeShippingBar.classList.add('show');
      } else {
        freeShippingBar.classList.remove('show');
      }
    })
    .catch(err => {
      console.warn('Could not detect country:', err);
      // Fallback: hide the bar if detection fails
      document.querySelector('.free-shipping-bar')?.classList.remove('show');
    });
}

// Run the function as early as possible
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', handleFreeShippingDisplay);
} else {
  handleFreeShippingDisplay();
}

// Also run when the cart is updated
//document.addEventListener('cart:updated', handleFreeShippingDisplay);

// Listen for Shopify's checkout data updates
//document.addEventListener('checkout:updated', handleFreeShippingDisplay);